<template>
  <strong v-show="isGranted('VIEW_LEGAL_PHRASES')" class="text-uppercase">
    <small>{{ label }}</small>
  </strong>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { isPreLoss } from '@/client/client';
import isGranted from '@/auth/isGranted';

export default defineComponent({
  props: {
    dateOfLoss: {
      type: String,
      required: true,
    },
    postedAt: {
      type: String,
      required: true,
    },
  },
  computed: {
    label(): string {
      if (isPreLoss(this.dateOfLoss, this.postedAt)) {
        return 'Pre-loss';
      }
      return 'Post-loss';
    },
  },
  methods: { isGranted },
});
</script>
